/**
 * Feuille de brouillon — prix de la calculatrice.
 *
 * Le bouton qui pose le résultat d'un calcul numérique (« 15 × 34 = » → 510)
 * est TOUJOURS proposé. Gratuit si l'exercice autorise la calculatrice ; sinon
 * il coûte des HORA selon la difficulté de la question, retirés de la ligne où
 * le résultat est posé. Pur : aucun DOM.
 */

export type CalcDifficulty = 'easy' | 'medium' | 'hard';

const COST: Record<CalcDifficulty, number> = { easy: 1, medium: 2, hard: 3 };

/** HORA retirés à chaque usage de la calculatrice (0 si elle est autorisée). */
export function calculatorCost(allowed: boolean, difficulty?: string | null): number {
  if (allowed) return 0;
  return COST[difficulty as CalcDifficulty] ?? COST.easy;
}
